// Third-party libraries
import React from "react";
import { useParams } from "react-router-dom";

// Local modules
import { storage } from "../../utils";
import styleCodes, { isBand } from "../../utils/styleCodes";
import Bands from "../products/productDetails/Bands";
import ProductDetailPage from "../products/productDetails/ProductDetailPage";
import Charms from "../products/productDetails/Charms";
import CoinsBullion from "../products/productDetails/CoinsBullions";

const MILL_DETAIL_CODES = new Set([
  "GR",
  "SD",
  "SDC",
  "SR",
  "SRB",
  "FLX",
  "SDB",
  "ALL",
  "FS",
  "BUL",
  "DSK",
  "ML",
  "AE",
  "LW",
  "SWD",
  "SWR",
]);

const JEWELRY_GROUP_MAP = {
  CIRCLES: "Circles",
  WRB: "Ring Blanks",
  WAS: "Washers",
  CHM: "Charms",
};

function extractStyles(pathname) {
  if (!pathname) {
    return "";
  }
  const segments = pathname.split("/");
  return segments.slice(2).join("/");
}

function getRecentlyViewed() {
  const rawValue = storage.getSessionStorageItem("hsRecentlyViewedProducts");
  try {
    return JSON.parse(rawValue || "null") || [];
  } catch (error) {
    return [];
  }
}

export default function Product(props) {
  const { ProductStyleCode } = useParams();
  const { location } = props;

  const recentlyViewed = getRecentlyViewed();
  const productStyles = extractStyles(location?.pathname) || ProductStyleCode;
  const isMillProduct = styleCodes.millProducts.includes(ProductStyleCode);
  const jewelryProductGroup =
    location?.state?.productGroup ??
    JEWELRY_GROUP_MAP[ProductStyleCode] ??
    "Jewelry";

  if (isBand(ProductStyleCode)) {
    return (
      <Bands
        ProductStyleCode={ProductStyleCode}
        ProductGroup="Bands"
        isMill={false}
        RecentlyViewed={recentlyViewed}
        {...props}
      />
    );
  }

  if (ProductStyleCode === "CHM") {
    return (
      <Charms
        ProductStyleCode={ProductStyleCode}
        ProductGroup="Charms"
        isMill={false}
        RecentlyViewed={recentlyViewed}
        {...props}
      />
    );
  }

  if (ProductStyleCode === "COINS BULLION") {
    return (
      <CoinsBullion
        ProductStyleCode={ProductStyleCode}
        ProductGroup="Circles"
        RecentlyViewed={recentlyViewed}
        isMill={false}
        {...props}
      />
    );
  }

  if (isMillProduct) {
    const productGroup = MILL_DETAIL_CODES.has(ProductStyleCode)
      ? "Mill"
      : "WireTubing";

    return (
      <ProductDetailPage
        ProductStyleCode={ProductStyleCode}
        ProductGroup={productGroup}
        RecentlyViewed={recentlyViewed}
        isMill
        {...props}
      />
    );
  }

  return (
    <ProductDetailPage
      ProductStyleCode={productStyles}
      ProductGroup={jewelryProductGroup}
      RecentlyViewed={recentlyViewed}
      isMill={false}
      {...props}
    />
  );
}
